import React from 'react';
import './Bookings.css';

const Bookings = () => {
  return (
    <section className="bookings-flyer">
      <h1>KHAYELITSHA YOUTH CHOIR PRESENTS</h1>
      <h2>RATES 2025 / 2026</h2>
      <ul className="rates-list">
        <li>WEDDINGS R9 000.00</li>
        <li>FUNERALS R8 000.00</li>
        <li>EVENTS R8 500.00</li>
        <li>UMGIDI R6 000.00</li>
      </ul>
      <h3>INFORMATION GUIDE</h3>
      <p className="phone-number">0688924694</p>
      <p className="email">E-MAIL: KHAYELITSHAYOUTHCHOIR@GMAIL.COM</p>
      <p className="additional-phone">+27 72 161 1140</p>
      <div className="logos">
        <img src="./images/UthandoLogo.png" alt="Uthando South Africa" className="logo" />
        <img src="./images/KYCLogo.png" alt="Khayelitsha Youth Choir" className="logo" />
        <img src="./images/SouthAfricanChoirLogo.png" alt="South African Choir" className="logo" />
      </div>
    </section>
  );
};

export default Bookings;
